<section class="info-section-container">
  <div class="info-section-content" [class.cb]="isCasasBahia">
    <img *ngIf="!isCasasBahia" [src]="assets.brandMascot" class="maskot-img" alt="imagem do mascote da marca">

    <div class="card-container">
      <h1 *ngIf="isCasasBahia">Facilidade e tranquilidade para pagar ou negociar em um único lugar!</h1>
      <h1 *ngIf="!isCasasBahia">Tenha o controle do seu carnê em um único lugar.</h1>

      <ul *ngIf="isCasasBahia">
        <app-feature-card *ngFor="let feature of featuresCB" 
          [title]="feature.title" 
          [description]="feature.description"
          [iconSrc]="feature.iconSrc">
        >
        </app-feature-card>
        <li class="cta-card">
          <div class="last-card">
            <img [src]="assets.installmentIcon" alt="2ª via do Carnê">
            <h3>
              Parcele <strong>sem cartão*</strong>
            </h3>
            <button type="button" (click)="handleOpenCarneDigital()" mat-stroked-button color="primary">
              Comprar com carnê
            </button>
          </div>
        </li>
      </ul>

      <ul *ngIf="!isCasasBahia">
        <li>
          <div class="title-container">
            <img [src]="assets.secondCopy" alt="2ª via do Carnê">
            <h3>2ª via do Carnê</h3>
          </div>

          <div class="item-description">
            <p>
              Pague suas
              parcelas aqui
            </p>
          </div>
        </li>
        <li>
          <div class="title-container">
            <img [src]="assets.renegotiation" alt="2ª via do Carnê">
            <h3>Renegociação</h3>
          </div>
          <div class="item-description">
            <p>
              Revise, crie ou ajuste seus carnês
            </p>
          </div>
        </li>
        <li>
          <div class="title-container">
            <img [src]="assets.specialDiscounts" alt="2ª via do Carnê">
            <h3>Descontos especiais</h3>
          </div>
          <div class="item-description">
            <p>
              Tenha descontos exclusivos.
            </p>
          </div>
        </li>
        <li class="hide-on-cb">
          <div class="title-container">
            <img [src]="assets.pixPayment" alt="2ª via do Carnê">
            <h3>Pague com Pix</h3>
          </div>
          <div class="item-description">
            <p>
              Pague suas parcelas com Pix.
            </p>
          </div>
        </li>

        <li class="hide-on-pf">
          <div class="last-card">
            <img [src]="assets.installmentIcon" alt="2ª via do Carnê">
            <h3>
              Parcele <strong>sem cartão*</strong>
            </h3>
            <button type="button" (click)="handleOpenCarneDigital()" mat-stroked-button color="primary">
              Comprar com carnê
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>